import { OkrReviewCyclesState } from './interfaces';

export const okrReviewCyclesInitialState: OkrReviewCyclesState = {
  items: [],
  loading: false,
  init: false,
};

export const storeName = 'okrReviewCycles';
